// components/process-units/InletCompression.js
import React, { useState } from 'react';

const InletCompression = ({ config, updateConfig }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Handle input changes
  const handleInputChange = (field, value) => {
    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      updateConfig({
        [field]: numValue
      });
    }
  };

  return (
    <div className="process-unit-card">
      <div 
        className="unit-header" 
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3>Inlet Compression</h3>
        <span className={`expand-icon ${isExpanded ? 'expanded' : ''}`}>
          {isExpanded ? '▼' : '▶'}
        </span>
      </div>
      
      {isExpanded && (
        <div className="unit-content">
          <p className="unit-description">
            Inlet compression raises the pressure of the gas to the required level for efficient processing
            in the downstream units. This is typically one of the major energy consumers in a gas plant.
          </p>
          
          <div className="parameter-group">
            <div className="parameter-row">
              <label>Discharge Pressure (bar)</label>
              <input
                type="number"
                min="0"
                step="1"
                value={config.dischargePresure}
                onChange={(e) => handleInputChange('dischargePresure', e.target.value)}
              />
            </div>
            
            <div className="parameter-row">
              <label>Compressor Efficiency (%)</label>
              <input
                type="number"
                min="0"
                max="100"
                step="1"
                value={config.efficiency * 100}
                onChange={(e) => handleInputChange('efficiency', e.target.value / 100)}
              />
            </div>
            
            <div className="parameter-row">
              <label>Number of Stages</label>
              <input
                type="number"
                min="1"
                max="5"
                step="1"
                value={config.stageCount}
                onChange={(e) => handleInputChange('stageCount', e.target.value)}
              />
            </div>
            
            <div className="parameter-row">
              <label>Compressor Type</label>
              <select 
                value={config.compressorType || 'centrifugal'}
                onChange={(e) => updateConfig({ compressorType: e.target.value })}
              >
                <option value="centrifugal">Centrifugal</option>
                <option value="reciprocating">Reciprocating</option>
                <option value="axial">Axial</option>
              </select>
            </div>
            
            <div className="parameter-row">
                              <label>Driver Type</label>
              <select 
                value={config.driverType || 'electricMotor'}
                onChange={(e) => updateConfig({ driverType: e.target.value })}
              >
                <option value="electricMotor">Electric Motor</option>
                <option value="gasTurbine">Gas Turbine</option>
                <option value="gasEngine">Gas Engine</option>
                <option value="steamTurbine">Steam Turbine</option>
              </select>
            </div>
            
            <div className="parameter-row">
              <label>Intercooler Temperature (°C)</label>
              <input
                type="number"
                min="0"
                max="100"
                step="1"
                value={config.intercoolerTemp || 40}
                onChange={(e) => handleInputChange('intercoolerTemp', e.target.value)}
              />
            </div>
            
            <div className="parameter-row">
              <label>Pressure Ratio per Stage</label>
              <input
                type="number"
                min="1"
                max="5"
                step="0.1"
                value={config.pressureRatio || 2.5}
                onChange={(e) => handleInputChange('pressureRatio', e.target.value)}
              />
            </div>
          </div>
          
          <div className="unit-info-box">
            <h4>Engineering Notes</h4>
            <ul>
              <li>Compression power is proportional to the logarithm of the pressure ratio.</li>
              <li>Using multiple stages with intercooling significantly reduces power consumption.</li>
              <li>Driver efficiency varies by type: electric motors (90-95%), gas turbines (30-40%), gas engines (40-45%).</li>
              <li>Reciprocating compressors are better for high pressure ratios but have higher maintenance costs.</li>
              <li>Centrifugal compressors are preferred for high throughput applications with moderate pressure ratios.</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default InletCompression;